import styled from "@emotion/styled";

export const Root = styled.div`
  display: flex;

  border-block-end: solid 1px #999999;
`;

export const StyledInput = styled.input`
  flex-grow: 1;

  inline-size: 100%;
  padding: 0;

  color: #000000;

  outline: 0;

  appearance: none;
`;
